import { render } from "./RectangleCutout.vue?vue&type=template&id=3fc48dd3"
import script from "./RectangleCutout.vue?vue&type=script&lang=js"
export * from "./RectangleCutout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__